import WavingHandIcon from "@mui/icons-material/WavingHand";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAuth } from "../../auth";

export default function WelcomeHeader() {
    const { user } = useAuth();
    const { t } = useTranslation();
    const displayName = user?.name?.split(" ")[0] || t("common.user");

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return t("dashboard.welcomeGreeting.morning");
        if (hour < 18) return t("dashboard.welcomeGreeting.afternoon");
        return t("dashboard.welcomeGreeting.evening");
    };

    return (
        <Box
            sx={{
                minWidth: 0,
                width: { xs: "100%", md: "auto" },
                flex: { md: "1 1 260px" },
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="h5" fontWeight={700} whiteSpace="nowrap">
                    {getGreeting()}, {displayName}!
                </Typography>
                <WavingHandIcon sx={{ fontSize: 26, color: "warning.main" }} />
            </Box>
            <Typography variant="body2" color="text.secondary" mt={0.25} whiteSpace="nowrap">
                {t("dashboard.activitiesSummary")}
            </Typography>
        </Box>
    );
}
